import { ChatService } from '@common/lib/api';
import * as chat from './types';
import * as estimate from '@common/store/modules/estimate/types';
import { downloadFile } from '@common/lib/common/utils';
import * as common from '@common/store/modules/common/types';

const actions = {
  async [chat.FETCH_CHATROOMS](context, params) {
    let { data } = await ChatService.getChatRooms(params);
    context.commit(chat.SET_CHATROOMS, data);

    return data;
  },
  async [chat.FETCH_CHATROOM](context, params) {
    if (params.uuid) {
      let { data } = await ChatService.getChatRoom(params);
      context.commit(chat.SET_CHATROOM, data);

      return data;
    } else {
      let { data } = await ChatService.getChatRoomById(params);
      context.commit(chat.SET_CHATROOM, data);

      return data;
    }
  },
  async [chat.FETCH_CHATROOM_WITH_STORE](context, params) {
    let { data } = await ChatService.getChatRoomWithStore(params);
    context.commit(chat.SET_CHATROOMS_WITH, data);

    return data;
  },
  async [chat.FETCH_CHATROOM_WITH_MEMBER](context, params) {
    let { data } = await ChatService.getChatRoomWithMember(params);
    context.commit(chat.SET_CHATROOMS_WITH, data);

    return data;
  },
  async [chat.FETCH_CHATMESSAGES](context, params) {
    const { data } = await ChatService.getChatMessages(params);
    context.commit(chat.SET_CHATMESSAGES, data);

    return data;
  },
  async [chat.FETCH_CHATMESSAGES_BY_SYSTEM_TYPE](context, params) {
    const { data } = await ChatService.getChatMessagesBySystemType(params);
    context.commit(chat.SET_CHATMESSAGES_SYSTEM_TYPE, data);

    return data;
  },
  async [chat.FETCH_CHATMESSAGE_BY_SYSTEM_TYPE](context, params) {
    const { data } = await ChatService.getChatMessageBySystemType(params);
    context.commit(chat.SET_CHATMESSAGE_SYSTEM_TYPE, data);

    return data;
  },
  async [chat.CREATE_CHATROOM](context, params) {
    let { data } = await ChatService.createChatRoom(params);
    context.commit(chat.SET_CHATROOM, data);

    return data;
  },
  async [chat.SYNC_CHATROOM](context, params) {
    let { data } = await ChatService.syncChatRoom(params);

    return data;
  },
  // inlateList에서 메시지 가져오기.
  // localStorage에 있으면 가져오고 없으면 서버에서 가져온다.
  async [chat.GET_CHATMESSAGES](context, params) {
    const FIRST_INDEX = 1;
    const {
      chatRoomType,
      uuid,
      size,
      messageIdx,
      startIdx,
      listMinIdx,
    } = params;
    const key = `perce-chatroom-${uuid}`;
    let storageData = await localStorage.getItem(key);
    if (!storageData) {
      storageData = {
        minIdx: Number.MAX_SAFE_INTEGER,
        maxIdx: Number.MAX_SAFE_INTEGER,
        messageIdx: 0,
        messages: [],
      };
    } else {
      storageData = JSON.parse(storageData);
    }
    const { minIdx, maxIdx, messages: storageMessages } = storageData;
    const storageMessageIdx = storageData.messageIdx;
    const serverMessageIdx = messageIdx;

    let newStartIdx = startIdx;
    let newEndIdx = newStartIdx;
    let newSize = size;
    if (newStartIdx === undefined) {
      if (serverMessageIdx > size) {
        newStartIdx = serverMessageIdx - size + 1;
      } else {
        newStartIdx = FIRST_INDEX;
        newSize = serverMessageIdx - newStartIdx + 1;
      }
    }
    newEndIdx = newStartIdx + newSize - 1;
    console.log(
      `newStartIdx: ${newStartIdx}, newEndIdx: ${newEndIdx}, newSize: ${newSize}`,
    );

    //localstorage안에 가져와야하는 메시지들이 있는지 체크
    if (storageMessages.length > 0) {
      console.log('getLocal');
      let fIndex = storageMessages.findIndex(m => m.messageIdx == newStartIdx);
      if (fIndex >= 0) {
        let eIndex = storageMessages.findIndex(m => m.messageIdx == newEndIdx);
        if (eIndex >= 0) {
          //가져와야하는 size만큼 있는지.
          if (eIndex - fIndex + 1 === newSize) {
            // 맨 앞(1)이면 0까지 가져온다.
            if (newStartIdx === 1) fIndex = 0;
            const data = storageMessages.slice(fIndex, eIndex + 1);
            console.log(data);
            return context.commit(chat.SET_CHATMESSAGES_BY_MESSAGE_IDX, {
              messages: data,
            });
          }
        }
      }
    }

    //없거나 size만큼 없으면 서버에서 가져온다.
    const { data } = await ChatService.getChatMessagesByMessageIdx({
      ...params,
      startIdx: newStartIdx,
      size: newSize,
    });
    if (data.length > 0) {
      //localstorage 저장.
      const newMessages = context.commit(chat.SET_CHATMESSAGES_LOCALSTORAGE, {
        chatRoomType,
        uuid,
        messageIdx: serverMessageIdx,
        messages: data,
      });
      //console.log('xxxx', context);
      //state에 저장
      return context.commit(chat.SET_CHATMESSAGES_BY_MESSAGE_IDX, {
        messages: context.state.tempNewMessages,
      });
    }
  },
  // 서버에서 메시지 가져오기
  async [chat.SET_CHATMESSAGES_BY_MESSAGE_IDX](context, data) {
    context.commit(chat.SET_CHATMESSAGES_BY_MESSAGE_IDX, data);
  },
  //소켓으로 받은 경우 메시지 처리
  async [chat.RECEIVE_CHATMESSAGE](context, params) {
    const {
      chatRoomType,
      uuid,
      messageIdx,
      messages,
      append,
      skipStore,
    } = params;
    const newMessages = context.commit(chat.SET_CHATMESSAGES_LOCALSTORAGE, {
      chatRoomType,
      uuid,
      messageIdx,
      messages,
      append,
    });
    //console.log('xxxx', context);
    if (!skipStore)
      context.commit(chat.SET_CHATMESSAGES_BY_MESSAGE_IDX, {
        messages: context.state.tempNewMessages,
        append,
      });
  },
  [chat.CHATMESSAGES_RESET_STATE](context) {
    context.commit(chat.CHATMESSAGES_RESET_STATE);
  },
  [chat.CHATROOMS_WITH_RESET_STATE](context) {
    context.commit(chat.CHATROOMS_WITH_RESET_STATE);
  },
  [chat.CHATROOMS_RESET_STATE](context) {
    context.commit(chat.CHATROOMS_RESET_STATE);
  },
  [chat.CHATROOM_RESET_STATE](context) {
    context.commit(chat.CHATROOM_RESET_STATE);
  },
  async [chat.UPLOAD_FILE](context, params) {
    const { data } = await ChatService.uploadFile(params);
    return data;
  },
  async [chat.SET_POST_PROCESSING](context, data) {
    context.commit(chat.SET_POST_PROCESSING, data);
  },
  async [chat.UPDATE_MEMBER_SCREEN_ACTIVED](context, params) {
    const { data } = await ChatService.modifyScreenActived(params);
    return data;
  },
  async [chat.UPDATE_MEMBER_SCREEN_ACTIVED_ALL](context, params) {
    const { data } = await ChatService.modifyScreenActivedAll(params);
    return data;
  },
  async [chat.RESET_CHAT_CACHE](context, params) {
    const { data } = await ChatService.resetChatCache(params);
    return data;
  },
  [chat.SET_CHATROOM](context, data) {
    context.commit(chat.SET_CHATROOM, data);
  },
  [chat.CHATMESSAGES_SYSTEM_TYPE_RESET_STATE](context) {
    context.commit(chat.CHATMESSAGES_SYSTEM_TYPE_RESET_STATE);
  },
  [chat.CHATMESSAGE_SYSTEM_TYPE_RESET_STATE](context) {
    context.commit(chat.CHATMESSAGE_SYSTEM_TYPE_RESET_STATE);
  },
  async [chat.SEND_CHATMESSAGE_MANUAL](context, params) {
    const { data } = await ChatService.sendChatMessageManual(params);
    return data;
  },
  async [chat.EXCEL_DOWNLOAD_CHAT_MESSAGES_SYSTEM_TYPE](context, param) {
    const response = await ChatService.downloadExcelChatMessagesBySystemType(
      param,
    );
    downloadFile(response);
  },
  async [chat.SEND_ESTIMATE](context, params) {
    const { data } = await ChatService.sendEstimate(params);
    context.dispatch(estimate.ROOT_SET_ESTIMATION_REQUEST_AT, params, {
      root: true,
    });
    return data;
  },
  async [chat.SEND_BOOKING](context, params) {
    await ChatService.sendBooking(params);
    //  return data;
  },
  async [chat.SEND_INTERNETCOMMERCE](context, params) {
    await ChatService.sendInternetCommerce(params);
    //  return data;
  },
  async [chat.SEND_ESTIMATE_STORES](context, params) {
    console.log('SEND_ESTIMATE_STORES');
    await ChatService.sendEstimateStores(params);
    //  return data;
  },
  async [chat.FETCH_CHATROOM_WATCH](context, params) {
    const { data } = await ChatService.getChatWatch(params);
    context.commit(chat.SET_CHATROOM_WATCH, data);
    return data;
  },
  async [chat.FETCH_CHATROOM_BLOCK](context, params) {
    console.log(params);
    const { data } = await ChatService.setChatBlock(params);
    return data;
    // const { data } = await ChatService.setChatBlock(params);
    // context.commit(chat.SET_CHATROOM, data);
    // return data;
  },
  async [chat.FETCH_CHATROOM_CHATLISTTYPE](context, params) {
    let { data } = await ChatService.setChatListType(params);
    return data;
  },
  async [chat.SEND_MOBILE_REQUEST](context, params) {
    await ChatService.sendMobileRequest(params);
    //  return data;
  },
  // 채팅방에 열람 확인 ( 사용안함 - 20231120 )
  async [chat.FETCH_CHATROOM_CHECK_LIMIT](context, params) {
    console.log('FETCH_CHATROOM_CHECK_LIMIT');
    console.log(params);
    let { data } = await ChatService.getChatRoomCheckLimit(params);

    return data;
  },
  async [chat.REPORT_CHAT](context, params) {
    console.log('[REPORT_CHAT]');
    await ChatService.setChatReport(params);
  },
  async [chat.MESSAGE_NOTICE](context, params) {
    console.log('[MESSAGE_NOTICE]');
    await ChatService.chatMessageNotice(params);
  },
  // 1:1문의 읽지않은 개수
  async [chat.FETCH_CHATMESSAGE_CHECKNEWREPLY](context, params) {
    let { data } = await ChatService.getCheckNewReply(params);
    return data;
  },
  // 상담내역 별로 새로운 메시지들
  async [chat.FETCH_CHATROOMS_NEW_MESSAGES](context) {
    let { data } = await ChatService.getChatRoomsNewMessages();
    return data;
  },

  // 프로모션 채팅글 생성
  async [chat.SEND_CHATMESSAGE_PROMOTION](context, params) {
    let { data } = await ChatService.chatRoomPromotionMessage(params);
    return data;
  },
};

export default actions;
